import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'roleName',
    standalone: true
})
export class RoleNamePipe implements PipeTransform {

    transform(role: string | null | undefined): string {
        if (!role) return 'Unknown';

        if (role === 'SYSTEM') return 'System';

        const parts = role.replace('SAMPLE_STUDIO_', '').split('_');

        if (!parts.length) return 'Unknown';

        // Convert ['PROCESS', 'OWNER'] => 'Process Owner'
        return parts
            .map(p => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
            .join(' ');
    }
}